import axiosInstance from '../axiosInstance';

export const translationApi = {
    post: (path, params, options, cancelToken) =>
        axiosInstance
            .post(`/translation${path}`, params, {
                ...options,
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            }),
    get: (path, params, options, cancelToken) =>
        axiosInstance
            .get(
                `/translation${path}`,
                { ...params, ...options },
                {
                    cancelToken: cancelToken?.token
                }
            )
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response?.data;
            })
};

export const getResources = async (params) => translationApi.get('/GetTranslationResources', { params });
export const searchTranslations = async (params) => translationApi.post('/Search', params);
export const searchSuspiciousTranslations = async (params) => translationApi.post('/SearchSuspicious', params);
export const saveTranslations = async (params) => translationApi.post('/Save', params);
export const createTranslationPair = async (params) => translationApi.post('/CreatePair', params);
export const translationPairExists = async (params) => translationApi.post('/Exists', params);
export const deleteTranslation = async (params) => translationApi.post('/Delete', params);
